/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import '../../common/address';
import './document';
import '../../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "identityverifier": {
        "nested": {
          "model": {
            "nested": {
              "PersonalAttributes": {
                "fields": {
                  "givenName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "middleName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "familyName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "birthDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 4,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.address.Address",
                    "id": 5,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "identificationDocument": {
                    "type": ".squareup.identityverifier.model.PersonalAttributes.IdentificationDocument",
                    "id": 12,
                    "rule": "optional"
                  },
                  "rawPersonalId": {
                    "type": "string",
                    "id": 7
                  },
                  "personalIdFideliusToken": {
                    "type": "string",
                    "id": 8
                  },
                  "ssnLast4": {
                    "type": "string",
                    "id": 9
                  }
                },
                "nested": {
                  "IdentificationDocument": {
                    "fields": {
                      "type": {
                        "type": ".squareup.identityverifier.model.DocumentType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "issuingCountry": {
                        "type": ".squareup.common.countries.Country",
                        "id": 2,
                        "rule": "optional"
                      },
                      "issuingState": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "number": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "expirationDate": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "personal_id": {
                    "oneof": ["rawPersonalId", "personalIdFideliusToken", "ssnLast4"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.PersonalAttributes && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.PersonalAttributes?.nested?.IdentificationDocument) {
  $root.addJSON(jsonData);
}

/**
 * Container of personal attributes.
 *
 * SOURCE PersonalAttributes @ squareup/identityverifier/model/personal_attributes.proto at 16:1
 */
export const PersonalAttributes = $root.lookupType('squareup.identityverifier.model.PersonalAttributes');
fixType(PersonalAttributes);
Builder.createAndAttachToType(PersonalAttributes);
/**
 * Details extracted from the provided document, if processed.
 *
 * SOURCE IdentificationDocument @ squareup/identityverifier/model/personal_attributes.proto at 65:3
 */
PersonalAttributes.IdentificationDocument = $root.lookupType('squareup.identityverifier.model.PersonalAttributes.IdentificationDocument');
fixType(PersonalAttributes.IdentificationDocument, {
  type: {
    required: true
  },
  issuingCountry: {
    required: true
  }
});
Builder.createAndAttachToType(PersonalAttributes.IdentificationDocument);